import { useNavigate } from 'react-router-dom';
import { AnalysesPage } from '@practium/features/analyses';
import type { AnalysesPermissions, AnalysesTab } from '@practium/features/analyses';
import { usePermissions } from '@practium/features/permissions';

export const AnalysesPageAdmin = () => {
	const navigate = useNavigate();
	const { abilities } = usePermissions();

	const permissions: AnalysesPermissions = {
		canCreate: abilities.can('create', 'samples'),
		canEdit: abilities.can('update', 'samples'),
		canDelete: abilities.can('delete', 'samples'),
	};

	const handleAddNew = (tab: AnalysesTab) => {
		navigate(`/analises/novo?type=${tab}`);
	};

	const handleViewItem = (tab: AnalysesTab, id: string) => {
		navigate(`/analises/ver?type=${tab}&id=${id}`);
	};

	return (
		<AnalysesPage
			permissions={permissions}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
		/>
	);
};
